import React, { useContext, useMemo } from 'react'

import SolidExclamationTriangleIcon from 'components/Luxkit/Icons/solid/SolidExclamationTriangleIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import Tooltip from 'components/Luxkit/Tooltip'
import TripContext from 'tripPlanner/contexts/TripContext'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}
export default function OutsideTripDatesToolTip({ item }: Props) {
  const tripContext = useContext(TripContext)
  const isItemOutsideOfTripDates: boolean = useMemo(() => {
    if (tripContext?.startDate && tripContext?.endDate) {
      let isInValidStartDate = false
      let isInValidEndDate = false
      if (item.startDate) {
        isInValidStartDate =
          item.startDate < tripContext.startDate ||
          item.startDate > tripContext.endDate
      }
      if ('endDate' in item && item.endDate) {
        isInValidEndDate =
          item.endDate < tripContext.startDate ||
          item.endDate > tripContext.endDate
      }
      return isInValidStartDate || isInValidEndDate
    }
    return false
  }, [item, tripContext?.startDate, tripContext?.endDate])
  if (!isItemOutsideOfTripDates || !item.isInItinerary) return null
  return (
    <Tooltip description="The dates saved on this item sit outside the overall trip dates.">
      <BodyTextBlock
        startIcon={<SolidExclamationTriangleIcon colour="warning" size="XS" />}
        variant="small"
        weight="bold"
        colour="warning"
      >
        Date Conflict
      </BodyTextBlock>
    </Tooltip>
  )
}
